export default "__VITE_ASSET__CYz2PBzC__"